import { SET_SERVICE_PROVIDER_RESULT, ADD_SERVICE_PROVIDER, DELETE_SERVICE_PROVIDER, GET_SERVICE_PROVIDER, GET_SERVICE_PROVIDERS_LIST, GET_SERVICE_PROVIDER_WIDGET, SERVICE_PROVIDER_LIST_LOADER, SERVICE_PROVIDER_PROFILE_LOADER, SET_ERROR_SERVICE_PROVIDER, SET_SERVICE_PROVIDER, SET_SERVICE_PROVIDERS_LIST, SET_SERVICE_PROVIDER_DATE, SET_SERVICE_PROVIDER_WIDGET, SET_SERVICE_PROVIDER_WIDGET_LOADER, UPDATE_SERVICE_PROVIDER } from "./actionTypes";

export const getServiceProvidersList = data => ({
  type: GET_SERVICE_PROVIDERS_LIST,
  payload: data,
});

export const setServiceProvidersList = payload => ({
  type: SET_SERVICE_PROVIDERS_LIST,
  payload,
});

export const setServiceProvidersListLoader = () => ({
  type: SERVICE_PROVIDER_LIST_LOADER,
});

export const addServiceProvider = (contractor = {}, data = {}) => ({
  type: ADD_SERVICE_PROVIDER,
  payload: { contractor, data },
});

export const deleteServiceProvider = (id, data = {}) => ({
  type: DELETE_SERVICE_PROVIDER,
  payload: { id, data },
});

export const getServiceProviderProfile = id => ({
  type: GET_SERVICE_PROVIDER,
  payload: id,
});

export const setServiceProviderProfile = payload => ({
  type: SET_SERVICE_PROVIDER,
  payload,
});

export const updateServiceProviderProfile = (id, contractor = {}, data = {}) => ({
  type: UPDATE_SERVICE_PROVIDER,
  payload: { id, contractor, data },
});

export const setErrorServiceProviderProfile = payload => ({
  type: SET_ERROR_SERVICE_PROVIDER,
  payload,
});

export const setServiceProviderLoader = () => ({
  type: SERVICE_PROVIDER_PROFILE_LOADER,
});

export const getServiceProviderData = (params) => ({
  type: GET_SERVICE_PROVIDER_WIDGET,
  payload: params
})

export const setServiceProviderData = (data) => ({
  type: SET_SERVICE_PROVIDER_WIDGET,
  payload: data
})

export const setServiceProviderWidgetLoader = () => ({
  type: SET_SERVICE_PROVIDER_WIDGET_LOADER,
})

export const setDateServiceProvider = data => ({
  type: SET_SERVICE_PROVIDER_DATE,
  payload: data,
});

export const setResultServiceProvider = data => ({
  type: SET_SERVICE_PROVIDER_RESULT,
  payload: data,
});